export const DEFAULT_SHADOW_FILL = '#7258E0';

export const SHADOW_TYPE = {
    DROP: 0,
    BLURRED: 1
};
